@if (showMarketHelp) {
    <ms-market-help [optionGroup]="optionGroup" [eventHelpText]="eventHelpText" />
}
<div class="option-group-container player-combined-container triple">
    <ng-container *msShowInEpcot="false">
        <div class="option-group-header">
            <span></span> <span>{{ optionGroup.parameterTranslations?.columnOver }}</span>
            <span>{{ optionGroup.parameterTranslations?.columnUnder }}</span>
        </div>
    </ng-container>

    @for (group of optionGroups | slice: 0 : visibleOptionsLimit; track group.attribute) {
        <div class="option-name-combined-stats-container">
            <div class="option-name-combined-container">
                <div class="attribute-key">
                    <div class="option-combined-container" [class.headshot-combined-container]="isShowHeadshotImage">
                        <div class="combined">
                            <vn-icon size="6" name="theme-plus" />
                        </div>
                    </div>
                    <div class="option-attribute-container" [class.headshot-option-attribute-container]="isShowHeadshotImage">
                        @for (option of group.options; track $index) {
                            @if (isShowHeadshotImage) {
                                <div class="player-combined-headshot">
                                    <ms-participant-image
                                        class="participant-logo"
                                        [participantImage]="option.image"
                                        [showLogoColor]="true"
                                        [participantType]="participantType.Player"
                                        [sportId]="event.sport.id" />
                                    <div class="option-attribute-name">{{ option.name }}</div>
                                </div>
                            } @else {
                                <div class="option-attribute-name">{{ option.name }}</div>
                            }
                        }
                    </div>
                    @if (isCrmMarketPromoted(group)) {
                        <ms-promotion-badge class="no-title" />
                    }
                </div>
                @for (option of group.options; track option.id) {
                    <ms-option
                        [class.option-attribute-content]="isShowHeadshotImage"
                        [option]="option"
                        [tracking]="{ source: tracking, moduleType: trackingModuleType }"
                        [optionGroup]="optionGroup"
                        [event]="event"
                        [showPromoBadge]="!!crmPromoIdsMap.options[option.id]"
                        [sourceOfPick]="sourceOfPick"
                        [betDetails]="betDetails" />
                }
            </div>
            @if (showPlayerStats && event.playerStats && optionGroup.detailedGrouping.playerStatsProps) {
                <ms-player-stats
                    [playerStats]="event.playerStats"
                    [sportId]="event.sport.id"
                    [playerStatsProps]="optionGroup.detailedGrouping.playerStatsProps"
                    [playerIds]="getPlayers(group)"
                    [source]="optionGroup.source" />
            }
        </div>
        <div class="market-seperator" *msShowInEpcot="true"></div>
    }
</div>
@if (!isInSheetView) {
    <ms-option-panel-bottom-action [data]="showMoreData" (showMore)="onShowMore($event)" (showAllRequested)="showAllRequested.next()" />
}
